import Header from "./Header";
import Footer from "./Footer";
import MobileFixedCTA from "./MobileFixedCTA";
import { type ReactNode } from "react";

interface PageLayoutProps {
  children: ReactNode;
  className?: string;
}

export default function PageLayout({ children, className = "" }: PageLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col bg-airdoa-white">
      <Header />
      <main className={`flex-1 pt-16 md:pt-20 ${className}`}>
        {children}
      </main>
      <Footer />
      <MobileFixedCTA />
    </div>
  );
}